import { render, staticRenderFns } from "./FlowPlatform.vue?vue&type=template&id=36848182&scoped=true&"
import script from "./FlowPlatform.vue?vue&type=script&lang=js&"
export * from "./FlowPlatform.vue?vue&type=script&lang=js&"
import style0 from "./FlowPlatform.vue?vue&type=style&index=0&id=36848182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36848182",
  null
  
)

export default component.exports